

export default class PolicyDataCalculation {
    constructor(data) {
        this.data = data

    }

    calculateTotal(data, keys) {
        return keys.reduce((sum, key) => sum + (data[key] || 0), 0);
    }

    assignRanks(segments) {
        const sortedSegments = [...segments].sort((a, b) => b.value - a.value); // Sort descending by value
        return segments.map(segment => {
            const rank = sortedSegments.findIndex(s => s.group === segment.group) + 1;
            return { ...segment, rank };
        });
    }

    separateLastThreeRanks(segments) {
        const sortedSegments = [...segments].sort((a, b) => b.value - a.value); // Sort descending by value
        const topSegments = sortedSegments.slice(0, sortedSegments.length - 3); // Top segments excluding last 3
        const otherSegments = sortedSegments.slice(-3); // Last 3 segments

        return {
            top: topSegments,
            other: otherSegments
        };
    }

    processCountries(groupRanges) {
        return this.data.map(country => {
            const groupTotals = groupRanges.map(group => {
                const total = this.calculateTotal(country, group.keys || group.range);
                return {
                    group: group.group,
                    value: total
                };
            });

            // Assign ranks based on values
            const rankedSegments = this.assignRanks(groupTotals);

            // Separate the last three ranked segments into "Other"
            // const { top, other } = this.separateLastThreeRanks(rankedSegments);

            return {
                Region: country.Region,
                Country: country.Country,
                Total: country.Total,
                Flag: country.Flag,
                Categories: rankedSegments,

                // segments: {
                //     top, // Top ranked segments
                //     other // Last 3 ranked segments
                // }
            };
        });
    }

    calculateDistanceToFrontier(countriesData, groupRanges) {
        const countriesDTF = countriesData.map(country => {
            const countryDTF = groupRanges.map(group => {
                // Step 1.1: Calculate the sum for the country in the group
                const sum = this.calculateTotal(country, group.keys || group.range);

                // Step 1.2: Calculate the maximum sum for the group (frontier)
                const maxSum = Math.max(...countriesData.map(country => {
                    return this.calculateTotal(country, group.keys || group.range);
                }));

                // Step 1.3: Calculate DTF for the country in this group
                const dtf = maxSum - sum;

                return {
                    group: group.group,
                    DTF: dtf
                };
            });

            return {
                country: country.Country,
                DTF: countryDTF
            };
        });

        return countriesDTF;
    }


    // Function to get top 3 countries based on values of the "Other" segments
    getTopCountriesByOtherSegment(countriesData) {
        // Iterate over each country
        const countrySegments = countriesData.map(country => {
            return {
                Country: country.Country == 'Hong Kong SAR, China' ? 'Hong Kong SAR' : country.Country,
                segments: country.segments.other
            };
        });

        // Initialize an object to hold the top 3 countries for each "Other" segment
        const topCountriesBySegment = {};

        // Iterate over each "Other" segment and sort countries based on their segment value
        countrySegments.forEach(country => {
            country.segments.forEach(segment => {
                if (!topCountriesBySegment[segment.group]) {
                    topCountriesBySegment[segment.group] = [];
                }

                // Add the country and its segment value
                topCountriesBySegment[segment.group].push({
                    Country: country.Country,
                    Value: segment.value
                });
            });
        });

        // For each "Other" segment, sort the countries by the segment value and take the top 3
        Object.keys(topCountriesBySegment).forEach(segment => {
            topCountriesBySegment[segment] = topCountriesBySegment[segment]
                .sort((a, b) => b.Value - a.Value) // Sort descending by segment value
                .slice(0, 3); // Get top 3 countries
        });

        return topCountriesBySegment;
    }

    getTopCountriesByCategory(countriesData, groupRanges) {
        return groupRanges.map(group => {
            // Calculate sum for each country in the group
            const countriesWithSum = countriesData.map(country => {
                const sum = this.calculateTotal(country, group.keys || group.range);
                return { country: country.Country, sum };
            });

            // Sort countries by sum value in descending order and pick the top 3
            countriesWithSum.sort((a, b) => b.sum - a.sum);
            const top3Countries = countriesWithSum.slice(0, 3);

            return {
                group: group.group,
                topCountries: top3Countries
            };
        });
    }
}